function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "b"
}, React.createElement("rect", {
  width: 48,
  height: 48
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, React.createElement("g", {
  transform: "translate(3 6)",
  fill: "none"
}, React.createElement("path", {
  d: "M18.924,4.313a3,3,0,0,1,5.151,0L40.29,31.462A3,3,0,0,1,37.714,36H5.286A3,3,0,0,1,2.71,31.462Z",
  stroke: "none"
}), React.createElement("path", {
  d: "M 21.49999046325684 4.850902557373047 C 21.32934951782227 4.850902557373047 20.90409088134766 4.898384094238281 20.64145088195801 5.338165283203125 L 4.427421569824219 32.48725509643555 C 4.157939910888672 32.9384651184082 4.329849243164062 33.34132385253906 4.416259765625 33.49359512329102 C 4.502681732177734 33.64585494995117 4.760410308837891 34.00000381469727 5.285961151123047 34.00000381469727 L 37.71403884887695 34.00000381469727 C 38.23958969116211 34.00000381469727 38.49732208251953 33.64585494995117 38.583740234375 33.49359512329102 C 38.67015075683594 33.34132385253906 38.84206008911133 32.9384651184082 38.57257843017578 32.48725509643555 L 22.35853958129883 5.338172912597656 C 22.09588050842285 4.898384094238281 21.67062950134277 4.850902557373047 21.49999046325684 4.850902557373047 M 21.49999046325684 2.850902557373047 C 22.49680328369141 2.850902557373047 23.49361419677734 3.338165283203125 24.07562065124512 4.31268310546875 L 40.28966903686523 31.46177291870117 C 41.48392105102539 33.46144485473633 40.04319000244141 36.00000381469727 37.71403884887695 36.00000381469727 L 5.285961151123047 36.00000381469727 C 2.956809997558594 36.00000381469727 1.516078948974609 33.46144485473633 2.710330963134766 31.46177291870117 L 18.92436027526855 4.31268310546875 C 19.5063648223877 3.338165283203125 20.50317764282227 2.850902557373047 21.49999046325684 2.850902557373047 Z",
  stroke: "none",
  fill: "#091832"
})));

var SvgFigureTriangle = function SvgFigureTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFigureTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Figure Triangle.8c99afd5.svg";
export { ForwardRef as ReactComponent };